var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vnp-input-box"},[_c('ul',_vm._l((_vm.val),function(item,index){return _c('li',{key:index,class:{ active: _vm.activeIndex === index },on:{"click":function($event){return _vm.handleClickItem(index)}}},[_c('span',[_vm._v(_vm._s(item))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e39a6f5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vant-number-plate/vnp-input-box.vue
// module id = null
// module chunks = 